export interface IDatePickerDay {
  date: Date;
  isCurrentMonth: boolean;
  text: string;
}
